import { render, staticRenderFns } from "./replaceLink.vue?vue&type=template&id=f091ed24&scoped=true"
import script from "./replaceLink.vue?vue&type=script&lang=js"
export * from "./replaceLink.vue?vue&type=script&lang=js"
import style0 from "./replaceLink.vue?vue&type=style&index=0&id=f091ed24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f091ed24",
  null
  
)

export default component.exports